export default "__VITE_ASSET__4596fe4e__"